import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import SEOSection from './components/SEOSection';
import ArticleCards from './components/ArticleCards';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <CategoryGrid />
      <SEOSection />
      <ArticleCards />
      <Testimonials />
      <CTASection />
      <Footer />
    </main>
  );
}